export default class Flickity {

    processBar() {
        const options = {
            cellAlign: 'left',
            setGallerySize: false,
            freeScroll: true,
            watchCSS: true,
            prevNextButtons: false,
            pageDots: false,
        };
        $('[data-jsprocessbar]').flickity(options);
    }
}